import { register } from '@forter/core';
import { FcFormSection } from './FcFormSection.js';

register(FcFormSection);
